// @flow
import React from 'react';
import authAction from 'app/common/react/components/limitedLogin/authAction';
import i18n from 'app/common/lib/i18n';
import SendShareController from 'app/common/react/components/SendShareController/SendShareController';
import type { SendShareFlyoutButtonProps } from 'app/common/react/components/SendShareController/SendShareController';
import { Button } from 'gestalt';

const PinRepSendShareFlyoutButtonFullWidth = ({
  handleSendShareFlyoutButtonClick,
  viewType,
}: SendShareFlyoutButtonProps) => (
  <div className="pinRepSendShareFlyoutButton">
    <Button
      onClick={({ event }) => {
        if (event && event.stopPropagation) {
          event.stopPropagation();
        }
        authAction(handleSendShareFlyoutButtonClick)();
      }}
      text={i18n._('Send', 'Send a pin')}
      color="gray"
      accessibilityLabel={i18n._('Send', 'Accessible label to send a pin')}
    />
  </div>
);

export default SendShareController.makeSendShareButton(PinRepSendShareFlyoutButtonFullWidth);
